import { ChangeEvent } from 'react';

import { useIsMobileSize } from 'hooks';

import { Icon } from '../Icon';
import { Stack } from '../Stack';

import { LabelStyled, StyledCheckbox } from './Checkbox.styles';
import { CheckboxProps } from './types';

/**
 * Checkbox Component
 */
export const Checkbox = ({
  disabled,
  checked,
  size = 'medium',
  indeterminate,
  readOnly,
  onChange,
  label,
  labelProps = {
    placement: 'start',
    typographyProps: {},
    spacing: 8,
  },
}: CheckboxProps) => {
  /**
   * Handle Checkbox Change
   */
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange?.(event.target.checked);
  };

  const isMobile = useIsMobileSize();

  const checkbox = (
    <StyledCheckbox
      disableRipple
      checked={checked}
      checkedIcon={<Icon.Checked className="checkbox-checkedIcon" />}
      component="button"
      disabled={disabled}
      icon={
        <div className="checkbox-icon">
          <div />
        </div>
      }
      indeterminate={indeterminate}
      indeterminateIcon={
        <Icon.CheckedIntdeterminate className="checkbox-checkedIcon" />
      }
      readOnly={readOnly}
      size={isMobile ? 'small' : size}
      onChange={handleChange}
    />
  );

  if (!label) {
    return checkbox;
  }

  const { placement, typographyProps, spacing } = labelProps;

  return (
    <Stack alignItems="center" direction="row" spacing={spacing}>
      {placement === 'start' && checkbox}
      <LabelStyled {...typographyProps}>{label}</LabelStyled>
      {placement === 'end' && checkbox}
    </Stack>
  );
};
